// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Test Cases Modal */
.itc-overlay {
  --itc-primary: var(--primary, #2563eb);
  --itc-primary-soft: var(--primary-muted, rgba(37, 99, 235, 0.1));
  --itc-primary-ring: var(--primary-muted, rgba(37, 99, 235, 0.18));
  --itc-text: var(--text-primary, #111827);
  --itc-label: var(--text-secondary, #374151);
  --itc-muted: var(--text-muted, #6b7280);
  --itc-placeholder: var(--input-placeholder, #9ca3af);
  --itc-border: var(--border, #e5e7eb);
  --itc-input-border: var(--input-border, #d1d5db);
  --itc-surface: var(--modal-background, var(--surface, #ffffff));
  --itc-input: var(--input-background, #ffffff);
  --itc-subtle: var(--bg-tertiary, #f9fafb);
  --itc-hover: var(--surface-hover, #f3f4f6);

  position: fixed;
  inset: 0;
  z-index: 11000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: var(--modal-backdrop, rgba(17, 24, 39, 0.5));
  backdrop-filter: blur(2px);
  animation: itcFadeIn 0.15s ease-out;
}

.itc-panel {
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
  background: var(--itc-surface);
  border-radius: 16px;
  border: 1px solid var(--itc-border);
  box-shadow: var(--modal-shadow, 0 24px 48px -12px rgba(17, 24, 39, 0.3));
  overflow: hidden;
  animation: itcSlideUp 0.2s ease-out;
}

/* Header */
.itc-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 24px;
  border-bottom: 1px solid var(--itc-border);
}

.itc-header-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--itc-primary);
  background: var(--itc-primary-soft);
}

.itc-header-text {
  flex: 1 1;
  min-width: 0;
}

.itc-header-text h2 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--itc-text);
}

.itc-header-text p {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: var(--itc-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.itc-header-text p strong {
  color: var(--itc-text);
  font-weight: 600;
}

.itc-close {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--itc-muted);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.itc-close:hover:not(:disabled) {
  background: var(--itc-hover);
  color: var(--itc-text);
}

.itc-close:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Body */
.itc-form {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1;
}

.itc-body {
  padding: 20px 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.itc-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.itc-field > label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--itc-label);
}

.itc-required {
  color: var(--danger, #ef4444);
}

/* Template download */
.itc-template {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--itc-primary) 25%, transparent);
  background: var(--itc-primary-soft);
}

.itc-template-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--success, #15803d);
  background: var(--success-muted, #dcfce7);
}

.itc-template-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.itc-template-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--itc-text);
}

.itc-template-sub {
  font-size: 0.78rem;
  color: var(--itc-muted);
  line-height: 1.4;
}

.itc-template-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid var(--itc-primary);
  background: var(--itc-surface);
  color: var(--itc-primary);
  font-size: 0.8rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}

.itc-template-btn:hover,
.itc-template-btn:focus-visible {
  background: var(--itc-primary);
  color: #ffffff;
  text-decoration: none;
}

/* Environment dropdown (rendered inside the modal) */
.itc-dd {
  position: relative;
  width: 100%;
}

.itc-dd-trigger {
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 12px;
  font-size: 0.875rem;
  text-align: left;
  color: var(--itc-text);
  background: var(--itc-input);
  border: 1px solid var(--itc-input-border);
  border-radius: 10px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.itc-dd-trigger:focus-visible,
.itc-dd-trigger.is-open {
  border-color: var(--itc-primary);
  box-shadow: 0 0 0 3px var(--itc-primary-ring);
}

.itc-dd-trigger:disabled {
  background: var(--itc-subtle);
  color: var(--itc-placeholder);
  cursor: not-allowed;
}

.itc-dd-value {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.itc-dd-value.is-placeholder {
  color: var(--itc-placeholder);
}

.itc-dd-chevron {
  flex-shrink: 0;
  color: var(--itc-muted);
  transition: transform 0.15s;
}

.itc-dd-trigger.is-open .itc-dd-chevron {
  transform: rotate(180deg);
}

.itc-dd-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 5;
  background: var(--itc-surface);
  border: 1px solid var(--itc-border);
  border-radius: 10px;
  box-shadow: var(--shadow-lg, 0 12px 28px -8px rgba(17, 24, 39, 0.22));
  overflow: hidden;
  animation: itcFadeIn 0.12s ease-out;
}

.itc-dd-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid var(--itc-border);
  color: var(--itc-muted);
}

.itc-dd-search input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  font-size: 0.85rem;
  color: var(--itc-text);
  background: transparent;
}

.itc-dd-list {
  list-style: none;
  margin: 0;
  padding: 4px;
  max-height: 180px;
  overflow-y: auto;
}

.itc-dd-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 0.85rem;
  color: var(--itc-text);
  cursor: pointer;
}

.itc-dd-option.is-active {
  background: var(--itc-hover);
}

.itc-dd-option.is-selected {
  color: var(--itc-primary);
  font-weight: 600;
  background: var(--itc-primary-soft);
}

.itc-dd-option-label {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.itc-dd-empty {
  padding: 10px;
  font-size: 0.83rem;
  color: var(--itc-muted);
  text-align: center;
}

/* Dropzone */
.itc-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  padding: 28px 16px;
  border: 2px dashed var(--itc-input-border);
  border-radius: 12px;
  background: var(--itc-subtle);
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s, background 0.15s, transform 0.15s;
}

.itc-dropzone:hover,
.itc-dropzone:focus-visible {
  border-color: var(--itc-primary);
  background: var(--itc-primary-soft);
}

.itc-dropzone.is-dragging {
  border-color: var(--itc-primary);
  background: var(--itc-primary-soft);
  transform: scale(1.01);
}

.itc-dropzone-icon {
  width: 52px;
  height: 52px;
  margin-bottom: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--itc-primary);
  background: var(--itc-surface);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(17, 24, 39, 0.08));
}

.itc-dropzone-title {
  margin: 0;
  font-size: 0.9rem;
  color: var(--itc-label);
}

.itc-dropzone-title span {
  font-weight: 600;
  color: var(--itc-primary);
}

.itc-dropzone-hint {
  margin: 0;
  font-size: 0.78rem;
  color: var(--itc-muted);
}

/* Selected file */
.itc-file-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--itc-border);
  border-radius: 12px;
  background: var(--itc-surface);
}

.itc-file-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--success, #15803d);
  background: var(--success-muted, #dcfce7);
}

.itc-file-meta {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.itc-file-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--itc-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.itc-file-size {
  font-size: 0.78rem;
  color: var(--itc-muted);
}

.itc-progress {
  position: relative;
  height: 4px;
  margin-top: 6px;
  border-radius: 999px;
  background: var(--itc-border);
  overflow: hidden;
}

.itc-progress-bar {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 40%;
  border-radius: 999px;
  background: var(--itc-primary);
  animation: itcIndeterminate 1.1s ease-in-out infinite;
}

.itc-file-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.itc-link-btn {
  border: none;
  background: transparent;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--itc-primary);
  cursor: pointer;
}

.itc-link-btn:hover {
  background: var(--itc-primary-soft);
}

.itc-icon-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--itc-muted);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.itc-icon-btn:hover {
  background: var(--danger-muted, #fef2f2);
  color: var(--danger, #dc2626);
}

/* Alerts */
.itc-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--danger, #dc2626) 35%, transparent);
  background: var(--danger-muted, #fef2f2);
  color: var(--danger, #b91c1c);
  font-size: 0.83rem;
  line-height: 1.4;
}

.itc-alert svg {
  flex-shrink: 0;
  margin-top: 1px;
}

/* Footer */
.itc-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--itc-border);
  background: var(--itc-subtle);
}

.itc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 18px;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s, opacity 0.15s;
}

.itc-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.itc-btn-secondary {
  background: var(--itc-surface);
  color: var(--itc-text);
  border: 1px solid var(--itc-input-border);
}

.itc-btn-secondary:hover:not(:disabled) {
  background: var(--itc-hover);
}

.itc-btn-primary {
  background: var(--itc-primary);
  color: #ffffff;
  border: 1px solid var(--itc-primary);
  box-shadow: var(--shadow-xs, 0 1px 2px rgba(37, 99, 235, 0.3));
}

.itc-btn-primary:hover:not(:disabled) {
  filter: brightness(0.93);
}

.itc-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: itcSpin 0.7s linear infinite;
}

/* Responsive */
@media (max-width: 600px) {
  .itc-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .itc-panel {
    max-width: 100%;
    max-height: 92vh;
    border-radius: 16px 16px 0 0;
    animation: itcSheetUp 0.22s ease-out;
  }

  .itc-header,
  .itc-body,
  .itc-footer {
    padding-left: 16px;
    padding-right: 16px;
  }

  .itc-footer {
    flex-direction: column-reverse;
  }

  .itc-template {
    flex-wrap: wrap;
  }

  .itc-template-btn {
    width: 100%;
    justify-content: center;
  }

  .itc-btn {
    width: 100%;
  }
}

/* Animations */
@keyframes itcFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes itcSlideUp {
  from { opacity: 0; transform: translateY(12px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes itcSheetUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

@keyframes itcSpin {
  to { transform: rotate(360deg); }
}

@keyframes itcIndeterminate {
  0% { left: -40%; }
  100% { left: 100%; }
}

@media (prefers-reduced-motion: reduce) {
  .itc-overlay,
  .itc-panel,
  .itc-progress-bar,
  .itc-spinner {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/import-test-cases-modal.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,sCAAsC;EACtC,gEAAgE;EAChE,iEAAiE;EACjE,wCAAwC;EACxC,2CAA2C;EAC3C,uCAAuC;EACvC,oDAAoD;EACpD,oCAAoC;EACpC,gDAAgD;EAChD,+DAA+D;EAC/D,6CAA6C;EAC7C,yCAAyC;EACzC,0CAA0C;;EAE1C,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wDAAwD;EACxD,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,wEAAwE;EACxE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yEAAyE;EACzE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE,8BAA8B;EAC9B,cAAc;EACd,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gDAAgD;AAClD;;AAEA;;EAEE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,qEAAqE;EACrE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,iEAAiE;AACnE;;AAEA;;EAEE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,8DAA8D;AAChE;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6EAA6E;EAC7E,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,oCAAoC;EACpC,8DAA8D;AAChE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,eAAe;AACf;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,oCAAoC;EACtC;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE;;;;IAIE,qCAAqC;IACrC,uCAAuC;EACzC;AACF","sourcesContent":["/* Import Test Cases Modal */\n.itc-overlay {\n  --itc-primary: var(--primary, #2563eb);\n  --itc-primary-soft: var(--primary-muted, rgba(37, 99, 235, 0.1));\n  --itc-primary-ring: var(--primary-muted, rgba(37, 99, 235, 0.18));\n  --itc-text: var(--text-primary, #111827);\n  --itc-label: var(--text-secondary, #374151);\n  --itc-muted: var(--text-muted, #6b7280);\n  --itc-placeholder: var(--input-placeholder, #9ca3af);\n  --itc-border: var(--border, #e5e7eb);\n  --itc-input-border: var(--input-border, #d1d5db);\n  --itc-surface: var(--modal-background, var(--surface, #ffffff));\n  --itc-input: var(--input-background, #ffffff);\n  --itc-subtle: var(--bg-tertiary, #f9fafb);\n  --itc-hover: var(--surface-hover, #f3f4f6);\n\n  position: fixed;\n  inset: 0;\n  z-index: 11000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: var(--modal-backdrop, rgba(17, 24, 39, 0.5));\n  backdrop-filter: blur(2px);\n  animation: itcFadeIn 0.15s ease-out;\n}\n\n.itc-panel {\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 32px);\n  display: flex;\n  flex-direction: column;\n  background: var(--itc-surface);\n  border-radius: 16px;\n  border: 1px solid var(--itc-border);\n  box-shadow: var(--modal-shadow, 0 24px 48px -12px rgba(17, 24, 39, 0.3));\n  overflow: hidden;\n  animation: itcSlideUp 0.2s ease-out;\n}\n\n/* Header */\n.itc-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--itc-border);\n}\n\n.itc-header-icon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--itc-primary);\n  background: var(--itc-primary-soft);\n}\n\n.itc-header-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.itc-header-text h2 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--itc-text);\n}\n\n.itc-header-text p {\n  margin: 4px 0 0;\n  font-size: 0.85rem;\n  color: var(--itc-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.itc-header-text p strong {\n  color: var(--itc-text);\n  font-weight: 600;\n}\n\n.itc-close {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--itc-muted);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.itc-close:hover:not(:disabled) {\n  background: var(--itc-hover);\n  color: var(--itc-text);\n}\n\n.itc-close:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* Body */\n.itc-form {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1;\n}\n\n.itc-body {\n  padding: 20px 24px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.itc-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.itc-field > label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--itc-label);\n}\n\n.itc-required {\n  color: var(--danger, #ef4444);\n}\n\n/* Template download */\n.itc-template {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--itc-primary) 25%, transparent);\n  background: var(--itc-primary-soft);\n}\n\n.itc-template-icon {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--success, #15803d);\n  background: var(--success-muted, #dcfce7);\n}\n\n.itc-template-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.itc-template-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--itc-text);\n}\n\n.itc-template-sub {\n  font-size: 0.78rem;\n  color: var(--itc-muted);\n  line-height: 1.4;\n}\n\n.itc-template-btn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid var(--itc-primary);\n  background: var(--itc-surface);\n  color: var(--itc-primary);\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: background 0.15s, color 0.15s;\n}\n\n.itc-template-btn:hover,\n.itc-template-btn:focus-visible {\n  background: var(--itc-primary);\n  color: #ffffff;\n  text-decoration: none;\n}\n\n/* Environment dropdown (rendered inside the modal) */\n.itc-dd {\n  position: relative;\n  width: 100%;\n}\n\n.itc-dd-trigger {\n  width: 100%;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 0 12px;\n  font-size: 0.875rem;\n  text-align: left;\n  color: var(--itc-text);\n  background: var(--itc-input);\n  border: 1px solid var(--itc-input-border);\n  border-radius: 10px;\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.itc-dd-trigger:focus-visible,\n.itc-dd-trigger.is-open {\n  border-color: var(--itc-primary);\n  box-shadow: 0 0 0 3px var(--itc-primary-ring);\n}\n\n.itc-dd-trigger:disabled {\n  background: var(--itc-subtle);\n  color: var(--itc-placeholder);\n  cursor: not-allowed;\n}\n\n.itc-dd-value {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.itc-dd-value.is-placeholder {\n  color: var(--itc-placeholder);\n}\n\n.itc-dd-chevron {\n  flex-shrink: 0;\n  color: var(--itc-muted);\n  transition: transform 0.15s;\n}\n\n.itc-dd-trigger.is-open .itc-dd-chevron {\n  transform: rotate(180deg);\n}\n\n.itc-dd-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  z-index: 5;\n  background: var(--itc-surface);\n  border: 1px solid var(--itc-border);\n  border-radius: 10px;\n  box-shadow: var(--shadow-lg, 0 12px 28px -8px rgba(17, 24, 39, 0.22));\n  overflow: hidden;\n  animation: itcFadeIn 0.12s ease-out;\n}\n\n.itc-dd-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-bottom: 1px solid var(--itc-border);\n  color: var(--itc-muted);\n}\n\n.itc-dd-search input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  font-size: 0.85rem;\n  color: var(--itc-text);\n  background: transparent;\n}\n\n.itc-dd-list {\n  list-style: none;\n  margin: 0;\n  padding: 4px;\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.itc-dd-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  color: var(--itc-text);\n  cursor: pointer;\n}\n\n.itc-dd-option.is-active {\n  background: var(--itc-hover);\n}\n\n.itc-dd-option.is-selected {\n  color: var(--itc-primary);\n  font-weight: 600;\n  background: var(--itc-primary-soft);\n}\n\n.itc-dd-option-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.itc-dd-empty {\n  padding: 10px;\n  font-size: 0.83rem;\n  color: var(--itc-muted);\n  text-align: center;\n}\n\n/* Dropzone */\n.itc-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 6px;\n  padding: 28px 16px;\n  border: 2px dashed var(--itc-input-border);\n  border-radius: 12px;\n  background: var(--itc-subtle);\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.15s, background 0.15s, transform 0.15s;\n}\n\n.itc-dropzone:hover,\n.itc-dropzone:focus-visible {\n  border-color: var(--itc-primary);\n  background: var(--itc-primary-soft);\n}\n\n.itc-dropzone.is-dragging {\n  border-color: var(--itc-primary);\n  background: var(--itc-primary-soft);\n  transform: scale(1.01);\n}\n\n.itc-dropzone-icon {\n  width: 52px;\n  height: 52px;\n  margin-bottom: 4px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--itc-primary);\n  background: var(--itc-surface);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(17, 24, 39, 0.08));\n}\n\n.itc-dropzone-title {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--itc-label);\n}\n\n.itc-dropzone-title span {\n  font-weight: 600;\n  color: var(--itc-primary);\n}\n\n.itc-dropzone-hint {\n  margin: 0;\n  font-size: 0.78rem;\n  color: var(--itc-muted);\n}\n\n/* Selected file */\n.itc-file-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--itc-border);\n  border-radius: 12px;\n  background: var(--itc-surface);\n}\n\n.itc-file-icon {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--success, #15803d);\n  background: var(--success-muted, #dcfce7);\n}\n\n.itc-file-meta {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.itc-file-name {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--itc-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.itc-file-size {\n  font-size: 0.78rem;\n  color: var(--itc-muted);\n}\n\n.itc-progress {\n  position: relative;\n  height: 4px;\n  margin-top: 6px;\n  border-radius: 999px;\n  background: var(--itc-border);\n  overflow: hidden;\n}\n\n.itc-progress-bar {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 40%;\n  border-radius: 999px;\n  background: var(--itc-primary);\n  animation: itcIndeterminate 1.1s ease-in-out infinite;\n}\n\n.itc-file-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.itc-link-btn {\n  border: none;\n  background: transparent;\n  padding: 6px 8px;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--itc-primary);\n  cursor: pointer;\n}\n\n.itc-link-btn:hover {\n  background: var(--itc-primary-soft);\n}\n\n.itc-icon-btn {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--itc-muted);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.itc-icon-btn:hover {\n  background: var(--danger-muted, #fef2f2);\n  color: var(--danger, #dc2626);\n}\n\n/* Alerts */\n.itc-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid color-mix(in srgb, var(--danger, #dc2626) 35%, transparent);\n  background: var(--danger-muted, #fef2f2);\n  color: var(--danger, #b91c1c);\n  font-size: 0.83rem;\n  line-height: 1.4;\n}\n\n.itc-alert svg {\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n/* Footer */\n.itc-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--itc-border);\n  background: var(--itc-subtle);\n}\n\n.itc-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 18px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s, opacity 0.15s;\n}\n\n.itc-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.itc-btn-secondary {\n  background: var(--itc-surface);\n  color: var(--itc-text);\n  border: 1px solid var(--itc-input-border);\n}\n\n.itc-btn-secondary:hover:not(:disabled) {\n  background: var(--itc-hover);\n}\n\n.itc-btn-primary {\n  background: var(--itc-primary);\n  color: #ffffff;\n  border: 1px solid var(--itc-primary);\n  box-shadow: var(--shadow-xs, 0 1px 2px rgba(37, 99, 235, 0.3));\n}\n\n.itc-btn-primary:hover:not(:disabled) {\n  filter: brightness(0.93);\n}\n\n.itc-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: itcSpin 0.7s linear infinite;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .itc-overlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .itc-panel {\n    max-width: 100%;\n    max-height: 92vh;\n    border-radius: 16px 16px 0 0;\n    animation: itcSheetUp 0.22s ease-out;\n  }\n\n  .itc-header,\n  .itc-body,\n  .itc-footer {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .itc-footer {\n    flex-direction: column-reverse;\n  }\n\n  .itc-template {\n    flex-wrap: wrap;\n  }\n\n  .itc-template-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .itc-btn {\n    width: 100%;\n  }\n}\n\n/* Animations */\n@keyframes itcFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes itcSlideUp {\n  from { opacity: 0; transform: translateY(12px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes itcSheetUp {\n  from { transform: translateY(100%); }\n  to { transform: translateY(0); }\n}\n\n@keyframes itcSpin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes itcIndeterminate {\n  0% { left: -40%; }\n  100% { left: 100%; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .itc-overlay,\n  .itc-panel,\n  .itc-progress-bar,\n  .itc-spinner {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
